export default "__VITE_ASSET__BycKFBt___"